import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as esriLoader from 'esri-loader';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from 'material-ui/CircularProgress';
import SummariesList from './SummariesList';
import originFields from '../../defaults/PointOfOriginFields.json'
import theme from '../../muiTheme';
import './ReportingDialog.css';
import { filterOperations } from '../../redux/filter';
import { incidentsOperations } from "../../redux/incidentList";
import { history } from '../../index';

const styles = makeStyles(theme => ({
  root: {
   flexGrow: 1,
 },
 menuButton: {
   marginRight: theme.spacing(2),
 },
 heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  }
}));

class ReportingDialog extends Component {

  constructor (props) {
    super(props);

    this.child = React.createRef();

    this.state = {
      selectedSummaries: [],
      incidents: [],
      dataLoaded: false,
      isLoading: false,
      userMenuOpen: false,
      anchorEl: null
    }

    this.menuIconRefElement = null;

    this.setMenuIconInputRef = element =>
    {
        this.menuIconRefElement = element;
    };
  }
  
  componentWillReceiveProps(nextProps) {
    esriLoader.loadModules(['esri/geometry/support/webMercatorUtils'])
      .then(([WebMercatorUtils]) => {
        if (!this.state.isLoading && !this.state.dataLoaded) {
          this.setState({
            isLoading: true
          });

          var geographicExtent = WebMercatorUtils.webMercatorToGeographic(nextProps.extent);
          window.api.getIncidentDataForSummaries(geographicExtent, nextProps.definitionExpression).then((incidents) => {
            if (this.props.filter.geometry !== null) 
            {
              const allowedIds = this.props.incidentList.visibleIncidents.map(item => item.attributes[originFields.fireOccurenceRecordID]);
              const incidentsToUse = incidents.filter(i => allowedIds.includes(i.FireOccurenceRecordID));

              this.setState({
                incidents: incidentsToUse,
                dataLoaded: true,
                isLoading: false
              });
            }
            else {
              this.setState({
                incidents: incidents,
                dataLoaded: true,
                isLoading: false
              });
            }
          });
        }
      });
  }

  handleCheckboxChange = (name) => event =>
  {
    let summaries = this.state.selectedSummaries;

    if (event.target.checked)
    {
        if (this.state.selectedSummaries.includes(event.target.value))
            return;

        summaries.push(event.target.value);
        this.setState({
          selectedSummaries: summaries
        });
    }
    else
    {
      if (!this.state.selectedSummaries.includes(event.target.value))
          return;

      let newSummaries = summaries.filter(summary => summary !== event.target.value);
      this.setState({
        selectedSummaries: newSummaries
      });
    }
  };

generateFilterList = () => {

  debugger;
  const { filter } = this.props;

  const filters = [
    { label: "GACC", value: filter.gacc },
    { label: "Fire Causes", value: filter.fireCauses, isArray: true },
    { label: "Incident Type", value: filter.categories, isArray: true },
    { label: "State", value: filter.state },
    { label: "County", value: filter.county },
    { label: "Initial Fire Strategies", value: filter.strategies, isArray: true },
    { label: "Landowner Categories", value: filter.landownerCategories, isArray: true }
  ];

  const filterNodes = [
    <h2 key="ActiveFilters">Active Filters</h2>,
    ...filters
      .filter(f => f.value !== null && (f.isArray ? f.value.length > 0 : true))
      .map((f, index) => (
        <div key={index}>
          <b>{f.label}:</b> {f.isArray ? f.value.join(", ") : f.value}
        </div>
      ))
  ];

  if (filter.fireAcresMin !== null || filter.fireAcresMax !== null) {
    filterNodes.push(
      <div key="fireAcres">
        <b>Incident Size:</b> Min: {filter.fireAcresMin} Max: {filter.fireAcresMax}
      </div>
    );
  }

  return filterNodes;
};

userMenuClick = (event) => {
  event.preventDefault();

  this.setState({
    userMenuOpen: true,
    anchorEl: event.currentTarget,
  });
};

downloadCsv = ()  =>
{
  this.child.current.downloadCsv();
}


handleClose = ()  => {
  this.setState({
    userMenuOpen: false,
    anchorEl: null,
  });
}

  render() {

    const loadingSpinner = (this.state.isLoading) ? (  <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} />) : "";
    const actions = [
      <FlatButton
        label="Print"
        className="reporting-print-btn"
        primary={false}
        disabled={this.state.selectedSummaries.length === 0 || !this.state.dataLoaded}
        onClick={() => {

        history.push({
              pathname: '/reporting/print',
              state:
              {
                incidents: this.state.incidents,
                summaries: this.state.selectedSummaries,
                extent: this.props.extent,
                definitionExpression: this.props.definitionExpression,
                screenshot: this.props.screenshot
              }
            });
        }
      }
      />,
      <FlatButton
        label="Export"
        className="reporting-print-btn"
        onClick={this.downloadCsv}
        disabled={this.state.selectedSummaries.length === 0 || !this.state.dataLoaded}
      />,
      <FlatButton
        label="Close"
        className="reporting-print-btn"
        primary={true}
        onClick={this.props.onClose}
      />
    ];

    return (
      <Dialog
        open={true}
        actions={actions}
        modal={true}
        autoScrollBodyContent={true}
        contentStyle={{width: '80%', height:'70%', maxWidth: 'none', overflowy: 'auto'}}
        className="dialog-modal"
        >
        <AppBar position="static" className="no-print-column">
           <Toolbar variant="dense" className="no-print-column">
             <Typography variant="h6" color="inherit" className="no-print-column">
               Reporting
             </Typography>
         </Toolbar>
       </AppBar>

       <Paper>
       <div className="row">
          <div className="no-print-column">
            <h2 ref={this.setMenuIconInputRef}>Available Summaries</h2>
            <List className={styles.root}>
            {['County','Fire Cause','Fire Cause General','Jurisdictional Agency','Jurisdictional Unit', 'Protecting Unit', 'Protecting Agency', 'Incident Category','Landowner Category', 'Size Class', 'State'].map(value => {
              const labelId = `checkbox-list-label-${value}`;
              return (
                <ListItem key={value} role={undefined} dense button>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      value={value}
                      tabIndex={-1}
                      onChange={this.handleCheckboxChange(value)}
                      disableRipple
                      inputProps={{ 'aria-labelledby': labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value} />
                </ListItem>
              );
            })}
          </List>
              {loadingSpinner}
          </div>
          <div className="print-column">
          <div className="report-page">
          { this.generateFilterList() }
          </div>
          <SummariesList
            ref={this.child}
            key="SummariesList"
            summaries={this.state.selectedSummaries}
            incidents={this.state.incidents}
            definitionExpression={this.props.definitionExpression}
            extent={this.props.extent}
            screenshot={this.props.screenshot}
          />
          </div>
        </div>
        </Paper>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  filter: state.filter,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...filterOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingDialog)
